import type { SqlDriver } from './driver';
import { createLocalDb, type LocalDb } from './localDb';
import { runMigrations } from './migrations';
import { openWorkerDriver } from './workerDriver';

export async function openLocalDb(userId: string): Promise<{ db: LocalDb; driver: SqlDriver }> {
  const driver = await openWorkerDriver(userId);
  await runMigrations(driver);
  return { db: createLocalDb(driver), driver };
}
